<template>
  <div class="fixed-header" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
    <!-- if has summary fields add class 'with-summary' -->
    <v-layout align-center fill-height class="fixed-header-wrapper">
      <v-flex shrink class="text-truncate" pr-4>
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <h2 v-on="on" class="p-relative text-truncate">
              Metrics Dashboard
            </h2>
          </template>
          <span>Metrics Dashboard</span>
        </v-tooltip>
        <h4 class="pt-1 sub-header">
          Last refreshed - <span class="font-weight-bold">{{lastRefreshed}}</span>
        </h4>
      </v-flex>
      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-flex shrink fill-height class="action">
        <v-tooltip left color="secondary">
          <v-btn icon flat slot="activator" v-on:click.stop="toggleLayoutMode()">
            <font-awesome-icon size="lg" icon="check-circle" v-if="layoutMode"></font-awesome-icon>
            <font-awesome-icon size="lg" icon="grip-horizontal" v-if="!layoutMode"></font-awesome-icon>
          </v-btn>
          <span v-if="layoutMode">Save Layout</span>
          <span v-if="!layoutMode">Change Layout</span>
        </v-tooltip>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex shrink fill-height class="action">
        <v-tooltip left color="secondary">
          <v-btn icon flat slot="activator" v-on:click.stop="refreshData()">
            <v-icon color="secondary" size="24">refresh</v-icon>
          </v-btn>
          <span>Refresh data</span>
        </v-tooltip>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex shrink fill-height class="action">
        <v-menu
          nudge-top="30px"
          left
          offset-y
          origin="center center"
          transition="scale-transition"
        >
          <v-btn
            flat
            slot="activator"
            icon
            dark
            color="secondary"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="widgetDialog = true">
              <v-icon class="mr-2" color="secondary">widgets</v-icon>
              Create a new dashboard widget
            </v-list-tile>
            <v-list-tile @click="sectionDialog = true">
              <v-icon class="mr-2" color="secondary">view_agenda</v-icon>
              Create a new dashboard section
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <add-widget-dialog :widgetDialog=widgetDialog v-on:new-widget-cancelled="closeForm()" v-on:new-widget-added="closeForm()" :widget="newWidget"></add-widget-dialog>
    <add-dashboard-section-dialog :sectionDialog="sectionDialog" v-on:new-section-cancelled="closeSectionForm()" v-on:new-section-added="closeSectionForm()"></add-dashboard-section-dialog>
  </div>
</template>

<script>
import AddWidgetDialog from "./AddWidgetDialog.vue"
import AddDashboardSectionDialog from "./AddDashboardSectionDialog.vue"
import Helpers from "@/helpers.js"

export default {
  name: "MetricsDashboardHeader",
  components: { AddWidgetDialog, AddDashboardSectionDialog },
  data: () => ({
    widgetDialog: false,
    sectionDialog: false,
    newWidget: { type: 'number', style: 'outline', scale: 0 }
  }),
  props: {
    lastReloaded: {
      type: Date,
      required: true
    },
    layoutMode: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeForm() {
      this.widgetDialog = false
    },
    closeSectionForm() {
      this.sectionDialog = false
    },
    refreshData() {
      this.$emit('refresh-data')
    },
    toggleLayoutMode() {
      this.$emit('toggle-layout-mode')
    }
  },
  computed: {
    lastRefreshed() {
      return Helpers.formatTimeAsGmail(this.lastReloaded)
    }
  }
}
</script>
